import {
    localStorageQueryClient,
    STALE_TIME_RESOURCES,
} from "@impero-com/common/utils/query_client";
import { useSuspenseQuery } from "@tanstack/react-query";

import { getFeatureFlags } from "api/generated/feature-flags/feature-flags";
import { OrganizationFeatureFlags } from "api/generated/model";

const fallbackFlags: OrganizationFeatureFlags = {
    activityAutoCompletion: false,
    activityDueDateExtension: false,
    aiControlDescriptionCompletion: false,
    aiControlDescriptionCompletionSelection: false,
    aiControlTaskSuggestion: false,
    aiRiskMapInsights: false,
    controlEntities: false,
    controlHealthDashboard: false,
    controlHealthScoreActivities: false,
    controlTesting: false,
    controlTriggering: false,
    exportAsCSV: false,
    imperoShare: false,
    mcp: false,
    moneyTaskType: false,
    newDashboard: false,
    newNavigation: false,
    orgSettings: false,
    personalAccessTokens: false,
    publicApiAttachments: false,
    riskInsights: false,
    scim: false,
    userNotificationFrequency: false,
    userNotificationSettings: false,
};
const FEATURE_FLAGS_QUERY_KEY = "feature-flags";
export function useFeatureFlagsQuery() {
    return useSuspenseQuery(
        {
            queryKey: [FEATURE_FLAGS_QUERY_KEY],
            queryFn: async () => {
                const isGlobal =
                    window.location.hostname.split(".")[0] === "global";
                if (isGlobal) {
                    return fallbackFlags;
                }
                const { data, status } = await getFeatureFlags();
                // Firefox reports a request aborted by a hard navigation as a
                // resolved response with status 0 and an empty "" body — axios'
                // settle() treats the falsy status as success. Throw so
                // react-query keeps the last-good flags instead of caching "",
                // which would make `flag in data` throw. See sc-38969.
                if (status === 0) {
                    throw new Error("feature-flags request was aborted");
                }
                return data;
            },
            staleTime: STALE_TIME_RESOURCES,
        },
        localStorageQueryClient
    );
}
